<!--LEARNING PLAN TILE-->
<app-card-container title="Learning Plan" cardType="subscription" [description]="''">
  <!--LEARNING PLAN TILE CARDS-->
  <app-tile-layout class="learning-plan-tile" maxColumns="3">
    <ng-container
      *ngFor="
        let learningPlanTileItem of learningPlanTiles | slice : 0 : 3;
        trackBy: trackByLearningPlanTileItem
      ">
      <li>
        <div class="learning-plan-tile-container">
          <ng-template [ngIf]="learningPlanTileItem?.imageIcon">
            <a
              id="{{ learningPlanTileItem?.url }}"
              [attr.data-beyond-id]="learningPlanTileItem?.url"
              (click)="sendGoogleAnalytics('Subscription Tile', 'click', learningPlanTileItem?.url)"
              class="gen-neutral-black-link-no-text-decoration"
              target="_blank"
              href="{{ learningPlanTileItem?.url }}">
              <i class="{{ learningPlanTileItem?.imageIcon }} icon red large"></i>
              <span class="margin-left-small"> {{ learningPlanTileItem.title }} </span>
            </a>
          </ng-template>
        </div>
        <p class="learning-plan-tile-text">
          {{ learningPlanTileItem?.description | decodeEntities | truncate : 150 }}
        </p>
      </li>
    </ng-container>
  </app-tile-layout>
</app-card-container>
<!--END SUBSCRIPTION TILE-->
